// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"535":"login","922":"edit"}[chunkId] + "." + {"535":"bb5b1211","922":"9934f867"}[chunkId] + ".css";
};